import basemapBing from './../../assets/images/basemap_bing.png';
import basemapDark from './../../assets/images/basemap_dark.png';
import basemapDefault from './../../assets/images/basemap_default.png';
import basemapLight from './../../assets/images/basemap_light.png';
const constants = {
  pricePerSeatTooltip:
    'Estimate based on 6 month term in a 30-seat private suite.\n Includes amenities and light meeting room usage.\n Excludes custom IT, design modifications and parking',
  providersTooltip:
    'Known providers operating in this area. Does not indicate current availability at a location.',
  coworkingTooltip: '- Shared workspace\n- Shared amenities\n- Shared meeting rooms',
  suitesTooltip: '- Dedicated workspace\n- Shared amenities\n- Shared or private meeting rooms',
  enterpriseTooltip:
    '- Dedicated amenities\n- Dedicated meeting rooms\n- Private entrance\n- Customizable IT',
  avail: 'Available in this area',
  notAvail: 'Not available in this area',
  addClientBtnTooltip: 'Add a client location pin to map',
  notEnoughData: 'There is not enough information for this area',
  notAvailableData: 'There are no available data points for this area',
  surveyCompltionTime: 'Avg. Survey Completion Time',
  noOfSurveys: 'No. of Surveys',
  closedDeals: 'Closed Deals',
  providerResponseRate: 'Provider Response Rate',
  surveyCompltionTimeTooltip:
    'Average no. of business days from the time a deal is created to the time the client deliverable is produced',
  noOfSurveysTooltip: 'Total no. of surveys requested globally',
  closedDealsTooltip: 'Percentage of deals that were closed globally',
  providerResponseRateTooltip:
    'Providers who have responded to Agile surveys (Locations available or Not available)',
  apacRegion: 'APAC',
};

export const KEYS_TO_ANALYTICS_DATA_BY_TITLE = {
  [constants.surveyCompltionTime]: 'surveyAroundData',
  [constants.noOfSurveys]: 'noOfSurveysData',
  [constants.closedDeals]: 'closedDealsData',
  [constants.providerResponseRate]: 'providerResponsData',
};

export const themeOptions = {
  light: 'light',
  dark: 'dark',
};

export const BASEMAPS = {
  default: {
    id: 'default',
    name: 'Default',
    style: 'mapbox://styles/cbre-lig/cl6wo5g7p004314n01j208hj8',
    img: basemapDefault,
    theme: themeOptions.light,
  },
  dark: {
    id: 'dark',
    name: 'Dark',
    style: 'mapbox://styles/cbre-lig/cmb6kof6z000h01qj0er3dh79',
    img: basemapDark,
    theme: themeOptions.dark,
  },
  light: {
    id: 'light',
    name: 'Light',
    style: 'mapbox://styles/cbre-lig/cmb71yohp00rr01rub5b89zj2',
    img: basemapLight,
    theme: themeOptions.light,
  },
  bing: {
    id: 'bing',
    name: 'Bing Satellite',
    style: 'mapbox://styles/cbre-lig/cmfqyu4sa00mj01qkc4j4agwz',
    img: basemapBing,
    theme: themeOptions.light,
  },
};

export default constants;
